/**
 * Created by Daniel on 4/22/2020
 * Description:
 * ---------maintenance history-------------
 */
import { Thread } from './thread.model';
import { EntryType } from './entry-type.model';
import { Sentiment } from './sentiment.model';
import { EntityBrief } from './entity-brief.model';
import { Priority } from './priority.model';
import { DocumentEntry } from './document-entry.model';
import { EntryClass } from './entry-class.model';
import { NoteEntry } from './note-entry.model';

export class ThreadEntry extends Thread {
    threadEntryThreadId: string;
    threadEntryType: EntryType;
    threadEntrySentiment: Sentiment;
    threadEntrySource: EntityBrief;
    threadEntryCalculatedSubject: string;
    threadEntryPriority: Priority;
    // threadEntryAttachments is current notes
    threadEntryAttachments: Map<string, DocumentEntry>;
    threadEntrySubmitter: EntityBrief;
    threadEntryEntryClass: EntryClass;
    threadEntrySubject: string;
    threadEntryThreadPosition: number;
    threadEntryTotalNotesInThread: number;
    threadEntryEditable: boolean;
    threadEntryDeleable: boolean;
    threadEntryParseByThread: boolean;

    constructor() {
        super();
    }

    static parseEntry(serverResponse) {
        const threadEntry = new ThreadEntry();
        const entry = NoteEntry.parse(serverResponse);
        threadEntry.id = entry.id;
        threadEntry.entities = entry.entities;
        threadEntry.threadEntryAttachments = entry.attachments;
        threadEntry.displayDate = entry.displayDate;
        threadEntry.lastEditedDate = entry.lastEditDate;
        threadEntry.lastModifiedDate = new Date(0); // Follow the thead, it should be ingored
        threadEntry.submittedDate = entry.submittedDate;
        if (serverResponse.thread && serverResponse.thread.data) {
            threadEntry.notes = serverResponse.thread.data.notes.map(item => NoteEntry.parse(item.data));
            // sidenote display sort
            threadEntry.notes = threadEntry.notes.reverse();
            threadEntry.parentEntry = threadEntry.notes.find(noteEntry => noteEntry.threadPosition === 0);
            threadEntry.threadEntryThreadId = serverResponse.thread.data.id;
            serverResponse.thread.data.attachments.forEach(item => {
                const documentEntry = DocumentEntry.parse(item.data);
                if (!documentEntry.isEmbeddedImg) {
                    threadEntry.attachments.set(documentEntry.id, documentEntry);
                }
            });
            // there is no detail attachment data under note when using entry post endpoint
            threadEntry.notes.forEach(note => {
                if (note.attachments.size > 0) {
                    Array.from(note.attachments.keys()).forEach(key => {
                        if (threadEntry.attachments.has(key)) {
                            note.attachments.set(key, threadEntry.attachments.get(key));
                        } else {
                            // remove embedded image from attachment
                            note.attachments.delete(key);
                        }
                    });
                }
            });
        }
        threadEntry.threadEntryType = entry.type;
        threadEntry.threadEntrySentiment = entry.sentiment;
        threadEntry.threadEntrySource = entry.source;
        threadEntry.threadEntryCalculatedSubject = entry.calculatedSubject;
        threadEntry.threadEntryPriority = entry.priority;
        threadEntry.threadEntrySubmitter = entry.submitter;
        threadEntry.threadEntryEntryClass = entry.entryClass;
        threadEntry.threadEntrySubject = entry.subject;
        threadEntry.threadEntryThreadPosition = entry.threadPosition;
        threadEntry.threadEntryTotalNotesInThread = entry.totalNotesInThread;
        threadEntry.threadEntryEditable = entry.editable;
        threadEntry.threadEntryDeleable = entry.deletable;
        threadEntry.threadEntryParseByThread = false;

        return threadEntry;
    }

    static parseThread(serverResponse) {
        const threadEntry = new ThreadEntry();
        const thread = Thread.parse(serverResponse);
        // assign value for the properties which extend from thread
        threadEntry.id = thread.id;
        threadEntry.entities = thread.entities;
        threadEntry.attachments = thread.attachments;
        threadEntry.displayDate = thread.displayDate;
        threadEntry.lastEditedDate = thread.lastEditedDate;
        threadEntry.lastModifiedDate = thread.lastModifiedDate;
        threadEntry.notes = thread.notes;
        threadEntry.submittedDate = thread.submittedDate;
        threadEntry.parentEntry = thread.parentEntry;
        threadEntry.threadEntryThreadPosition = -1;
        threadEntry.threadEntryTotalNotesInThread = thread.notes.length;
        threadEntry.threadEntryThreadId = thread.id;
        threadEntry.threadEntryParseByThread = true;
        threadEntry.threadEntryAttachments = thread.attachments;
        // assign value for the properties which create in threadEntry
        const note = thread.notes.find(noteEntry => noteEntry.threadPosition === 0);
        threadEntry.threadEntryType = note.type;
        threadEntry.threadEntrySentiment = note.sentiment;
        threadEntry.threadEntrySource = note.source;
        threadEntry.threadEntryCalculatedSubject = note.calculatedSubject;
        threadEntry.threadEntryPriority = note.priority;
        threadEntry.threadEntrySubmitter = note.submitter;
        threadEntry.threadEntryEntryClass = note.entryClass;
        threadEntry.threadEntrySubject = note.subject;
        threadEntry.threadEntryEditable = note.editable;
        const flag = thread.notes.find(_note => {
            return _note.deletable === false;
        });
        threadEntry.threadEntryDeleable = !flag;

        return threadEntry;
    }
}
